import { gql } from '@apollo/client';
import { FieldGroupFragment } from '../fragments/FieldGroupFragment';
/**
 * @const FieldGroupsQuery
 * @since 1.0.0
 */
export const FieldGroupsQuery = gql `
  query FieldGroupsQuery($input: FieldGroupsInput) {
    fieldGroups(input: $input) {
      ...FieldGroupFragment
    }
  }

  ${FieldGroupFragment}
`;
